<template>
    <structure>
        <section class="my-account">
            <div class="title">
                <h1>Minha Conta</h1>
                <p>Mantenha os seus dados atualizados</p>
            </div>
            <div class="avatar-box">
                <section class="select-avatar">
                    <label>
                        <input type="file" @change="uploadImage">
                        <div class="photo" v-if="foto">
                            <img :src="foto">
                        </div>
                        <div class="photo" v-if="!foto && loadAvatar">
                            <img src="@/assets/imgs/no-avatar.png">
                        </div>
                        <section class="load-avatar" v-if="loadAvatar"></section>
                    </label>
                </section>
                <div class="text">Clique acima para selecionar</div>
            </div>
            <section class="access-data">
                <div class="title">
                    <h2>Identificação</h2>
                    <p>Informe seu nome e sobrenome</p>
                </div>
                <div class="box">
                    <form v-on:submit.prevent="updateProfile">
                        <div class="msg" v-if="message">{{message}}</div>
                        <div class="input-box">
                            <input id="input-first-name" type="text" v-model="formProfile.first_name" placeholder=" ">
                            <label for="input-first-name">
                                <span>Nome:</span>
                            </label>
                        </div>
                        <div class="input-box">
                            <input id="input-last-name" type="text" v-model="formProfile.last_name" placeholder=" ">
                            <label for="input-last-name">
                                <span>Sobrenome</span>
                            </label>
                        </div>
                        <div class="control">
                            <button type="submit" :class="indicatorProfile">Salvar alterações</button>
                        </div>
                    </form>
                </div>
            </section>
            <section class="access-data">
                <div class="title">
                    <h2>Dados de Acesso</h2>
                    <p>Atualize seus dados de acesso.</p>
                </div>
                <div class="box">
                    <form v-on:submit.prevent="update">
                        <div class="msg" v-if="message">{{message}}</div>
                        <div class="input-box">
                            <input id="input-assunto" type="text" v-model="form.email" placeholder="Digite o seu e-mail" @focus="message = ''">
                            <label for="input-assunto">
                                <span>E-mail</span>
                            </label>
                        </div>
                        <div class="input-box">
                            <input id="input-assunto" type="text" v-model="form.password" placeholder="Digite o seu e-mail" @focus="message = ''">
                            <label for="input-assunto">
                                <span>Senha</span>
                            </label>
                        </div>
                        <div class="input-box">
                            <input id="input-assunto" type="text" v-model="form.password_confirm" placeholder="Digite o seu e-mail" @focus="message = ''">
                            <label for="input-assunto">
                                <span>Confirmar Senha</span>
                            </label>
                        </div>
                        <div class="control" v-if="form.email">
                            <button type="submit" :class="indicator">Salvar alterações</button>
                        </div>
                    </form>
                </div>
            </section>
        </section>
    </structure>
</template>

<script>
    import structure from '@/templates/private'
    import mixinAutoResize from "../../../mixins/auto-resize.js";
    import { profile, storage } from "@/services";
    export default {
        name: 'login',
        mixins: [ mixinAutoResize ],
        components: { structure },
        data() {
            return {
                foto: false,
                user: null,
                loadAvatar: false,
                loadUpdate: false,
                loadProfile: false,
                message: '',
                form: {
                    email: '',
                    password: '',
                    password_confirm: '',
                },
                formProfile: {
                    first_name: '',
                    last_name: '',
                }
            }
        },
        computed: {
            indicator(){
                return this.loadUpdate ? 'loading' : ''
            },
            indicatorProfile(){
                return this.loadProfile ? 'loading' : ''
            }
        },
        methods: {
            uploadImage(e){
                const image  = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                // reader.onload = e =>{
                //     this.foto = e.target.result;
                // };

                let form = new FormData()
                form.append("file", image);
                this.loadAvatar = true
                profile.avatar(form).then( response => {
                    storage.updateUser('avatar', response.data)
                    this.loadAvatar = false
                    this.foto = response.data
                })
            },
            userData(){
                this.user = storage.getUser()
                if(this.user.avatar){
                    this.foto = this.user.avatar
                    this.form.email = this.user.email
                    this.formProfile.first_name = this.user.first_name
                    this.formProfile.last_name = this.user.last_name
                }
            },
            update(){
                this.loadUpdate = true
                profile.access(this.form).then( () => {
                    storage.updateUserData('email', this.form.email)
                    this.loadUpdate = false
                }, error => {
                    this.message = error.response.data.message
                    this.loadUpdate = false
                })
            },
            updateProfile(){
                this.loadProfile = true
                profile.update(this.formProfile).then( () => {
                    this.loadProfile = false

                    storage.updateUserData('first_name', this.formProfile.first_name)
                    storage.updateUserData('last_name', this.formProfile.last_name)
                })
            },
        },
        created(){
            this.userData()
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
